/*
 * Handles requests for Topic Response Translation.
 */

define(["backbone", "configuration/properties", "messaging/messenger"], function (
  Backbone,
  Properties,
  Messenger,
) {
  "use strict";

  const ResponseTranslationModel = {};

  ResponseTranslationModel.responseTranslation = Backbone.Model.extend({
    defaults: {
      responseText: "",
      sourceLocaleId: 0,
      targetLocaleId: 0,
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      const intentId = Messenger.reqres.request("current:topic:id");
      return `${Properties.rootURL}/${kbId}/intents/${intentId}/translation`;
    },
  });

  return ResponseTranslationModel;
});
